import { matchPath } from 'react-router-dom';
import { landingClusters } from '../assets/landingClusters';
import AppRoutes from '../routes/appRoutes';

const routePathEntries = Object.entries(AppRoutes).filter(
  ([key, value]) => !value.includes('*'),
);
const LANDING_PAGE_DISPLAY_IDS = landingClusters.map((c) => c.displayId);

const getPathParams = (pathname) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of routePathEntries) {
    const match = matchPath(
      {
        path: value,
        exact: true,
        strict: true,
      },
      pathname,
    );

    if (match) {
      // ignore falsy landing page matches
      if (
        match.params?.displayId &&
        value === AppRoutes.LANDING &&
        !LANDING_PAGE_DISPLAY_IDS.includes(match.params.displayId)
      ) {
        // eslint-disable-next-line no-continue
        continue;
      }
      return { routeName: key, ...match.params };
    }
  }

  return {};
};

export default getPathParams;
